import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStateShareService } from '../../../services/navigation-state-share.service';
import { Router } from '@angular/router';
import { KeyValueData } from '../../../domains/common.domain';
import { InstallationFlowType } from '../../../constants/app.constants';
import { LocalStorageService } from '../../../services/local-storage.service';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
  selector: 'app-nav-steps',
  templateUrl: './nav-steps.component.html',
  styleUrls: ['./nav-steps.component.scss'],
})
export class NavStepsComponent implements OnInit {
  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const focusable = Array.from(document.querySelectorAll('.header-icon')) as HTMLElement[];
    const index = focusable.findIndex(el => el === document.activeElement);

    switch (event.key) {
      case 'ArrowRight':
        event.preventDefault();
        const next = focusable[index + 1] || focusable[0];
        next.focus();
        break;

      case 'ArrowLeft':
        event.preventDefault();
        const focusableMenuItems = Array.from(document.querySelectorAll('.menu-item')) as HTMLElement[];
        const prev = focusable[index - 1] || focusableMenuItems[0];
        prev?.focus();
        break;

      case 'Enter':
        const focusedElement = document.activeElement as HTMLElement;
        focusedElement.click();
        event.preventDefault();
        break;
    }
  }

  step: number = 0;
  currentInstallationFlow: string;
  installationFlow: KeyValueData;
  showTechnicalFormFirst: boolean;

  constructor(
    private stateShare: NavigationStateShareService,
    private route: Router,
    private localStorage: LocalStorageService,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit(): void {
    this.step = this.stateShare.getFormState();
    this.installationFlow = InstallationFlowType;
    this.currentInstallationFlow = this.localStorage.getItem('installation_flow');

    this.showTechnicalFormFirst =
      this.environmentService.showTechnicalFormFirst ||
      this.currentInstallationFlow === this.installationFlow.MainsConnection ||
      this.currentInstallationFlow === this.installationFlow.FeedInSystem ||
      this.currentInstallationFlow === this.installationFlow.TemporaryConnection ||
      this.currentInstallationFlow === this.installationFlow.ChangeHouseConnection ||
      this.currentInstallationFlow === this.installationFlow.ConversionToGas ||
      this.currentInstallationFlow === this.installationFlow.GridCompatibility;
  }

  traverseInsideFlow(target: string, isActiveTab: boolean): void {
    if (!isActiveTab) return;

    if (target === 'location') {
      this.route.navigate(['/jurisdiction']);
    } else if (target === 'personal-data') {
      this.route.navigate(['/personal-data']);
    } else if (target === 'facilities') {
      if (this.currentInstallationFlow === this.installationFlow.FeedInSystem) {
        this.route.navigate(['technical-data']);
      } else if (this.currentInstallationFlow === this.installationFlow.SiteElectricityMeterdata) {
        this.route.navigate(['site-electricity-technical-data']);
      } else if (this.currentInstallationFlow === this.installationFlow.GridCompatibility) {
        this.route.navigate(['gridcomp/technical-data']);
      } else if (
        this.currentInstallationFlow === this.installationFlow.MainsConnection ||
        this.currentInstallationFlow === this.installationFlow.TemporaryConnection ||
        this.currentInstallationFlow === this.installationFlow.ChangeHouseConnection ||
        this.currentInstallationFlow === this.installationFlow.ConversionToGas
      ) {
        this.route.navigate(['technician-form']);
      } else {
        this.route.navigate(['facilities-data']);
      }
    } else if (target === 'submit') {
      this.route.navigate(['documents-submission']);
    }
  }
}
